export function getLoaderScript(): HTMLScriptElement | null {
  const scripts = Array.from(document.querySelectorAll('script')) as HTMLScriptElement[];
  for (let i = scripts.length - 1; i >= 0; i--) {
    const script = scripts[i];
    if ((script.getAttribute('src') || '').includes('topbar')) return script;
  }
  return null;
}

export function resolveDefaultTopbarSrc(loaderScript: HTMLScriptElement | null = getLoaderScript()): string | null {
  if (!loaderScript?.src) return null;
  try {
    const baseUrl = new URL(loaderScript.src, window.location.href);
    return `${baseUrl.origin}/topbar`;
  } catch {
    return null;
  }
}
